"use client"

import BaseFormProvider from '../../../../../shared/components/forms/base-form-provider'
import { loginFormSchema } from '../../../schemas/login.schema'
import { LoginFormType } from '../../../types/login.type'
import React, { PropsWithChildren } from 'react'
import { LoginFormContextProvider } from '../../../contexts/login-form-context'

interface LoginFormProviderProps extends PropsWithChildren {
    prefilledRegion?: number
    prefilledRole?: 'homeowner' | 'volunteer'
    prefilledTeam?: string
}

function LoginFormProvider({
    children,
    prefilledRegion,
    prefilledRole,
    prefilledTeam,
}: LoginFormProviderProps) {
    return (
        <LoginFormContextProvider
            value={{ prefilledRegion, prefilledRole, prefilledTeam }}
        >
            <BaseFormProvider
                onSubmit={() => {}}
                schema={loginFormSchema}
                defaultValues={{
                    email: '',
                    password: undefined,
                    code: undefined,
                } as LoginFormType}
            >
                {children}
            </BaseFormProvider>
        </LoginFormContextProvider>
    )
}

export default LoginFormProvider